@if (open()) {
  <div
    class="d-flex alert"
     [ngClass]="{'alert-danger': alert?.priority === 'danger',
                  'alert-success': alert?.priority === 'success',
                  'alert-warning': alert?.priority === 'warning'}"
    @slideInOut>
    <span class="alert icon"
    [ngClass]="alert?.icon"></span>
    @if (alert?.message) {
      <span class="alert message">
        {{ alert?.message | translate }}
      </span>
    }
  </div>
}
